import { collectionEngineV1 } from '../apis';
import { toQuery } from '@debbie/common/dist/util';
const hooksAPI = collectionEngineV1('/webhooks');
export const create = (name, url, events, email, headers) => hooksAPI('POST', `/`, { body: { name, url, events, email, headers } });
export const getAll = () => hooksAPI('GET', `/`);
export const getItems = (query, quantity, from) => hooksAPI('GET', `/items?${toQuery(Object.assign({ quantity,
    from }, query))}`);
export const executeHookItem = (id) => hooksAPI('GET', `/items/execute/${id}`);
export const getItem = (id) => hooksAPI('GET', `/items/${id}`);
export const del = (id) => hooksAPI('DELETE', `/${id}`);
//# sourceMappingURL=hooks.js.map